import { jsxs, jsx, Fragment } from "react/jsx-runtime";
import { Stack, Heading, Text, Box, TextLink } from "braid-design-system";
import { useMemo } from "react";
import { relatedSearchWrapper } from "./RelatedSearch.css.mjs";
const TitledContent = ({
  title,
  children,
  headingLevel,
  headingDataAutomation,
  space = "none"
}) => {
  const headingData = headingDataAutomation ? { automation: headingDataAutomation } : void 0;
  return /* @__PURE__ */ jsxs(Stack, { space, children: [
    headingLevel && /* @__PURE__ */ jsx(Heading, { level: headingLevel, data: headingData, children: title }) || /* @__PURE__ */ jsx(Text, { weight: "strong", data: headingData, children: title }),
    children ? /* @__PURE__ */ jsx(Fragment, { children }) : null
  ] });
};
const noop = () => {
};
const RelatedSearch = ({
  title,
  links,
  titleSpace = "medium",
  onLinkClick = noop
}) => {
  const renderedLinks = useMemo(
    () => links.map((link, index) => {
      const { text, props } = link;
      const key = `related_search_${index}`;
      return /* @__PURE__ */ jsxs(
        Box,
        {
          marginBottom: "small",
          width: "full",
          "data-automation": key,
          children: [
            " ",
            /* @__PURE__ */ jsx(Text, { baseline: false, children: /* @__PURE__ */ jsx(TextLink, { ...props, onClick: () => onLinkClick(link, index), children: text }) })
          ]
        },
        key
      );
    }),
    [links, onLinkClick]
  );
  return /* @__PURE__ */ jsx(
    TitledContent,
    {
      headingLevel: "4",
      headingDataAutomation: "related_search_heading",
      space: titleSpace,
      title,
      children: /* @__PURE__ */ jsx(Box, { className: relatedSearchWrapper, children: renderedLinks })
    }
  );
};
export {
  RelatedSearch,
  TitledContent
};
